import React from "react";
import { Card, CardContent, CardTitle } from "../../misc/Card";
import { Button } from "../../misc/Button";
import { OpenhousePostProps } from "./types";
import { toast } from "react-toastify";
import CustomToast from "../../misc/CustomToast";

const VideoPosts: React.FC<OpenhousePostProps> = ({ listing, setIsOpen }) => {
    const isSyncing = listing?.isSyncing || false;

    const handleCreateVideoPosts = () => {
        if (
            !listing ||
            !listing.campaignId ||
            listing.campaignStatus?.toLowerCase() === "sold"
        ) {
            toast.error(
                <CustomToast
                    message="Your listing is either sold or does not have an active campaign."
                    type="error"
                />,
                { autoClose: 3000 }
            );
            return;
        }

        if (
            !listing ||
            !listing.campaignId ||
            listing.campaignStatus?.toLowerCase() !== "active"
        ) {
            toast.error(
                <CustomToast
                    message="Please create a campaign first."
                    type="error"
                />,
                { autoClose: 3000 }
            );
            return;
        }
        setIsOpen(true);
    };
    return (
        <Card className="mt-0">
            {/* {loading && <LoadingScreen />} */}
            <CardContent className="pt-6">
                <CardTitle className="mb-4">Video Showcase</CardTitle>
                <div className="flex flex-col justify-center">
                    <Button
                        variant="secondary"
                        onClick={handleCreateVideoPosts}
                        disabled={isSyncing}
                    >
                        Create Video Showcase Posts
                    </Button>
                </div>
            </CardContent>
        </Card>
    );
};

export default VideoPosts;
